import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetNetworkFilters,
	GetNetworkFiltersResponse,
	GetNetworkFiltersParams,
} from 'domain/usecases/private/guide-flow/medical-guide/get-network-filters';

export class RemoteGetNetworkFilters implements GetNetworkFilters {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetNetworkFiltersResponse>,
	) {}

	async get({
		signal,
		...params
	}: GetNetworkFiltersParams = {}): Promise<GetNetworkFiltersResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
